// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__Yykml","headerBlock":"style__headerBlock__mn1pe"};